<script setup lang="ts">
import ChatListEmpty from "@/views/Home/components/ChatListEmpty.vue";
import { isExpand } from "@/views/Home/useData/useHomePage";
import ChatListHistory from "@/views/Home/components/ChatListHistory.vue";
import { bindDialogue } from "@/views/Home/useData/module/chat";
import publicStore from "@/store/publicStore";
import {
  dialogueStatus,
  dialogueList,
  init,
  addDialogue,
} from "@/views/Home/useData/module/dialogue";

import { openLoginDialog } from "@/components/Dialogues/useData/login";
import { onBeforeMount, computed, watch } from "vue";
import { storeToRefs } from "pinia";
import { chatStatus } from "@/views/Home/useData/module/chat";
import { ElMessage } from "element-plus";

const { isLogin } = storeToRefs(publicStore());

onBeforeMount(() => {
  console.log("onBeforeMount");
  // init();

  //设置类型 聊天发送时设置
  // setType("deep-seek-v3");
  // setType("R1");
});

const isReplying = computed(() => {
  return chatStatus.isReplying;
});

const addNewDialogue = () => {
  if (!isLogin.value) {
    ElMessage.warning("请登录后使用");

    return openLoginDialog();
  }

  if (isReplying.value) {
    return ElMessage({
      message: "当前对话正在进行中，请先结束当前对话",
      type: "warning",
      duration: 1000,
    });
  }
  addDialogue();
};

watch(
  isLogin,
  () => {
    init();
  },
  {
    immediate: true,
  }
);
</script>

<template>
  <div class="chat-base" :class="{ 'base-compact': !isExpand }">
    <div class="add-new-btn" :class="{ 'btn-compact': !isExpand }">
      <el-tooltip
        class="box-item"
        effect="dark"
        content="开启新对话"
        placement="right"
        v-if="!isExpand"
      >
        <el-icon @click="addNewDialogue" :size="20" :color="`#000`"
          ><ChatLineSquare
        /></el-icon>
      </el-tooltip>
      <div v-if="isExpand" @click="addNewDialogue">开启新对话</div>
    </div>
    <ChatListEmpty v-if="dialogueList.length === 0" />
    <ChatListHistory v-else v-show="isExpand" />
  </div>
</template>

<style lang="scss" scoped>
.chat-base {
  width: 100%;
  height: 100%;
  flex: 1;
  overflow: hidden;
  padding: 16px;
  flex-direction: column;
  align-items: start;
  display: flex;

  .add-new-btn {
    width: 140px;
    height: 40px;
    padding: 8px;
    background: #dbeafe;
    border-radius: 16px;
    cursor: pointer;
    gap: 4px;

    &:hover {
      background: #dbeafe99;
    }
    color: #4d6bfe;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
  }

  .btn-compact {
    width: 40px;
    background: #dbeafe00;
    padding: 0px;
  }
}

.base-compact {
  padding-top: 0;
  align-items: center;
}
</style>
